import { Box } from '@/components/ui/box';
import { FlexRow } from '@/components/ui/flex';
import { Input } from '@/components/ui/input';
import { cn } from '@/utils/classUtils';
import { type ClassValue } from 'class-variance-authority/types';
import { SearchIcon } from 'lucide-react';
import { FC } from 'react';

const SearchBar: FC<{
  searchString: string;
  setSearchString: (value: string) => void;
  placeholder?: string;
  className?: ClassValue;
}> = props => {
  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    props.setSearchString(e.target.value.trimStart() || '');
  };

  return (
    <FlexRow
      p="1"
      br="lg"
      alignItems="center"
      className={cn(
        'h-9 border space-x-1 min-w-[160px] transition-all gap-2 border-neutral-300',
        props.className
      )}
    >
      <Box className="p-0.5">
        <SearchIcon className="text-secondary w-4 h-4" />
      </Box>
      <Input
        className="w-full border-0 p-0 focus:outline-none focus:ring-0 text-sm shadow-none"
        value={props.searchString}
        onChange={onChange}
        placeholder={props.placeholder}
      />
    </FlexRow>
  );
};
export { SearchBar };
